/**
 * Translate API
 *
 * Admin-only helper that the legacy Azure Function exposed at
 * `POST /api/translate`. The body was the raw English source string
 * and the response was a record of localised strings:
 *
 *   POST /api/translate
 *   Content-Type: text/plain
 *   Body: <english source>
 *
 *   Response: TranslationResult
 *
 * The replacement target is a Netlify function with the same contract.
 * Until that exists this stub echoes the input back as a placeholder.
 */

export type TranslationResult = {
  greek: string;
  german: string;
  french: string;
  dutch: string;
};

export const translateText = async (
  english: string,
): Promise<TranslationResult> => {
  const placeholder = (lang: string) => `[${lang}] ${english}`;
  await new Promise((resolve) => setTimeout(resolve, 100));
  return {
    greek: placeholder("el"),
    german: placeholder("de"),
    french: placeholder("fr"),
    dutch: placeholder("nl"),
  };
};
